import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../../../shared/services/admServices/accounts.service';

@Component({
  selector: 'adm-adver-stats',
  templateUrl: './adver-stats.html',
  styleUrls: ['./adver-stats.scss'],
})

export class adverstatsComponent implements OnInit {
  // chart options
  chartOption: any;
  // table options
  chart: any;

  constructor(private accountService: AccountService) {}

  ngOnInit() {
    this.getChart();
  }

  getChart(){

    this.accountService.getAdvertiserStats()
    .subscribe(
     data => {
      this.chart = data.data;
      this.setChart();
     },
     error => {
       console.log(error);
     });
  }

  setChart(){
    this.chartOption = {
      legend: {
        selected: {
          'All Offers today': false,
          'All active Offers today': false,
          'Total Conversions': true,
          'Total Revenue $': true
      }
      },
      toolbox: {
        show: true,
        orient: 'vertical',
        left: 'right',
        top: 'center',
        feature: {
          mark: { show: true },
          dataView: { show: false, readOnly: false },
          magicType: { show: true, type: ['stack'] },
          restore: { show: false },
          saveAsImage: { show: true }
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
        type: 'shadow'
        }
      },
      xAxis:  {  type: 'category',
                data: this.chart.advertisers
              },
      yAxis: {},
      series: [
        { type: 'bar',
          color: '#0d0394',
          name: 'All Offers today',
          data:  this.chart.allOffers,
          emphasis: {
            focus: 'series'
          },
          select: { label: {show: false} }
        },
        { type: 'bar',
          color: '#9801ee',
          name: 'All active Offers today',
          data: this.chart.allActiveOffers,
          emphasis: {
            focus: 'series'
          },
        },
        { type: 'bar',
          color: '#936413',
          name: 'Total Conversions',
          data: this.chart.conversions,
          emphasis: {
            focus: 'series'
          },
        },
        { type: 'bar',
          color: '#ff6018',
          name: 'Total Revenue $',
          // label: {show: true, position: 'inside', rotate: '90' },
          data: this.chart.revenue,
          emphasis: {
            focus: 'series'
          },
        }]
    };
  }
}
